module.exports = __webpack_public_path__ + "static/media/S4_03.2eccb665.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/STAGE4strobe/S4_03.png
// module id = 201
// module chunks = 0